<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  meta: [
    { name: 'description', content: 'Mi-Asahi CMS' },
    { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
    { charset: 'utf-8' },
    { property: 'og:type', content: 'website' }
  ]
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
